import { render, staticRenderFns } from "./RadarContentDetail.vue?vue&type=template&id=f5874432&scoped=true&"
import script from "./RadarContentDetail.vue?vue&type=script&lang=js&"
export * from "./RadarContentDetail.vue?vue&type=script&lang=js&"
import style0 from "./RadarContentDetail.vue?vue&type=style&index=0&id=f5874432&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5874432",
  null
  
)

export default component.exports